var SelectStyle = /* @__PURE__ */ ((SelectStyle2) => {
  SelectStyle2["Default"] = "default";
  SelectStyle2["Filter"] = "filter";
  return SelectStyle2;
})(SelectStyle || {});
export {
  SelectStyle
};
//# sourceMappingURL=types.js.map
